import { instanceViewerStats } from './instances'

export const getCurrentViewersCount = async (channelId: string) => {
    return await instanceViewerStats.get(`/liveevent-ivs-viewerstats?channel=${channelId}`)
}
